// extracted by mini-css-extract-plugin
module.exports = {"panoContainer":"PanoramaHolder_panoContainer__kER-6","closeButton":"PanoramaHolder_closeButton__8WHt7","objasniButton":"PanoramaHolder_objasniButton__1c5eo"};